import { api as apiCraft } from '@/store/interfaces/apiCraft'
import { api } from '@/store/interfaces/apiData'
import Vue from 'vue'

import data from '@/assets/data/data.json'

export default {
  namespaced: true,

  state: {
    slides: data.slides,
    sequences: [],
    presentation: [],
    loaded: false,
    themes: []
  },

  getters: {
    loaded: state => {
      return state.loaded
    },
    presentation: state => {
      return state.presentation
    },
    themes: state => {
      return state.themes
    },
    sequences: state => {
      return state.sequences
    },
    sequenceBySlug: state => slug => {
      return state.sequences.find(sequence => sequence.slug === slug )
    }
  },

  actions: {
    presentation ({ state, commit, dispatch }, slug) {
      const { request, cache } = apiCraft.getEntry(slug)

      // WHEN DECOMMENTER, CA SE MET A CHIER CA RACE
      // cache.then(async res => {
      //   if (res !== null) {
      //     commit('presentation', res)
      //     commit('sequences', res.lorealSequences)
      //     await dispatch('timecodes', res.lorealSequences)
      //     commit('loaded', true)
      //   }
      // })

      return request.then(async res => {
        commit('presentation', res)
        commit('sequences', res.lorealSequences)
        const themes = res.lorealSequences.reduce((accumulator, current) => {
          if (!accumulator.length || accumulator[accumulator.length - 1] !== current.lorealEnvironent) {
            accumulator.push(current.lorealEnvironent)
          }
          current.lorealEnvironentIndex = accumulator.length - 1
          return accumulator
        }, [])
        commit('themes', themes)
        await dispatch('timecodes', res.lorealSequences)
        commit('loaded', true)
      })
    },
    timecodes ({ state, commit }, sequences ) {
      let promises = []

      sequences.forEach((sequence, i) => {
        sequence.lorealSlides.forEach((slide, j) => {
          if (slide.generatedTimecodesUrl) {
            promises.push(new Promise(resolve => {
              const { request, cache } = api.getTimeCodes(slide.generatedTimecodesUrl)

              cache.then(res => {
                if (res !== null) {
                  commit('timecode', {timecodes: res.timepoints, slide: j, sequence: i})
                  resolve()
                }
              })

              request.then(res => {
                if (res !== null) {
                  commit('timecode', {timecodes: res.timepoints, slide: j, sequence: i})
                  resolve()
                }
              })
            }))
          }
        })
      })

      return Promise.all(promises)
    }
  },

  mutations: {
    loaded (state, payload) {
      state.loaded = payload
    },
    timecode (state, {timecodes, slide, sequence}) {
      timecodes.forEach(timecode => {
        timecode.markName = timecode.markName.split(':')[0]
      })
      Vue.set(state.sequences[sequence].lorealSlides[slide], 'timecodes',timecodes)
    },
    presentation (state, payload) {
      state.presentation = payload
    },
    sequences (state, sequences) {
      sequences.forEach((sequence, index) => {
        sequence.index = index
      })
      state.sequences = sequences
    },
    themes (state, payload) {
      state.themes = payload
    }
  }
}